<template>
  <div class="page-sign d-block st py-0">
      <div class="row g-0">
          <div class="col-md-7 col-lg-5 col-xl-4 col-wrapper">
              <div class="card card-sign">
                  <div class="card-header">
                      <div class="text-center">
                          <img src="assets/images/logo1.png" style="width: 120px; margin-bottom: -10px;" alt="" />
                      </div>
                      <div class="text-center">
                          <a href="#" class="text-center header-logo mb-3 mt-0">CLIC</a>
                      </div>
                      <h3 class="card-title">Reset Password</h3>
                      <p class="card-text">Please enter registered email</p>
                  </div>
                  <div class="card-body">
                      <form @submit.prevent="forgotPassword()">
                          <div class="mb-4">
                              <label class="form-label">Email <span class="text-danger"> *</span></label>
                              <input type="text" tabindex=1 class="form-control" placeholder="Enter email" :class="{ 'is-invalid': errors.email }" v-model="user.email" ref="email" />
                              <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                          </div>
                      </form>
                  </div>
                  <div class="card-footer text-end">
                        <div class="row">
                            <div class="col-md-6">
                                <router-link to="/" type="button" class="btn btn-sm btn-danger me-2"><i class="ri-close-line icon_hgt"></i>DISCARD</router-link>
                            </div>
                            <div class="col-md-6">    
                                <button  type="submit" class="btn btn-sm btn-primary" @click="forgotPassword()"><i class="ri-save-line icon_hgt"></i>SUBMIT</button>
                            </div>
                        </div>
                    </div>
              </div>
          </div>
          <div class="col d-none d-lg-block"><img src="assets/images/bg5.jpg" class="auth-img" alt="" /></div>
      </div>
  </div>
</template>
<script>
    export default {
    name: "ForgotPassword",
    data() {
        return {
            user: {
                email: '',
            },
            errors: {},
        };
    },
    mounted() {
        this.$refs.email.focus();
    },
    methods: {
        forgotPassword() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.errors = {};
            vm.$store.dispatch("auth", { uri: "forgotPassword", data: vm.user })
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch('setEmail',vm.user.email);
                    vm.$router.push('/reset_password');
                    
                })
                .catch(function (error) {
                    loader.hide();
                    const data = error.response?.data || {};
                    vm.errors = data.errors || {};
                    if (!vm.errors.email && data.message) {
                        vm.errors = { email: [data.message] };
                    }
                    vm.$store.dispatch("error", data.message || "The given data was invalid.");
                });
        },
    },
};
</script>
<style>
  .auth-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    mix-blend-mode: luminosity;
    opacity: .8!important;
}
.page-sign.d-block {
    background-image: linear-gradient(to right, #9ba9d8 40%, #5b7ce7 100%);
}
</style>
